import bannerMedia from '../Media/swrya-banner.jpg'

// Banner promocional de SWRYA que se muestra en toda ficha de producto (contenido estático).
export const swryaBanner = {
  media: bannerMedia,
  tag: "Control de activos en tiempo real",
  kicker: "WMS para retail y almacenes",
}

export const swryaModules = [
  {
    "title": "Auditorías y conteos cíclicos automáticos",
    "desc": "SWRYA programa qué contar y cuándo, compara contra el inventario esperado y te avisa las diferencias sin detener la operación."
  },
  {
    "title": "Planogramas digitales por punto de venta",
    "desc": "Compara el acomodo real contra el planograma ideal y detecta desviaciones en anaquel antes de que te cuesten una venta."
  },
  {
    "title": "Entradas con ubicación exacta",
    "desc": "Cada entrada a almacén queda registrada con su ubicación: sabes en todo momento dónde está cada activo, sin buscar dos veces."
  },
  {
    "title": "Control de activos en tiempo real",
    "desc": "Altas, bajas y movimientos entre almacenes o puntos de venta, siempre visibles y auditables desde un mismo lugar."
  }
]
